import { UseFormReturn } from 'react-hook-form';
import {
  Form,
  FormField,
  FormItem,
  FormMessage,
} from '@web/components/ui/form';

import { Brand } from '@shared/types';
import { InputAnimatedLabel } from '@web/components/ui/input-animated-label';

type BrandDetailsFormProps = {
  form: UseFormReturn<Brand>;
  onSubmit: (data: Brand) => Promise<void>;
  isEditMode: boolean;
  setIsSubmitting: (isSubmitting: boolean) => void;
};

export function BrandDetailsForm({
  form,
  onSubmit,
  isEditMode,
  setIsSubmitting,
}: BrandDetailsFormProps) {
  return (
    <Form {...form}>
      <form
        onSubmit={(e) => {
          setIsSubmitting(true);

          void form.handleSubmit(onSubmit)(e);
        }}
        className="space-y-4"
      >
        <div className="grid grid-cols-2 gap-4">
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <InputAnimatedLabel
                  label="Brand Name"
                  readOnly={!isEditMode}
                  {...field}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <InputAnimatedLabel
                  label="Email"
                  readOnly={!isEditMode}
                  type="email"
                  {...field}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="phone"
            render={({ field }) => (
              <FormItem>
                <InputAnimatedLabel
                  label="Phone"
                  readOnly={!isEditMode}
                  {...field}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="website"
            render={({ field }) => (
              <FormItem>
                <InputAnimatedLabel
                  label="Website"
                  readOnly={!isEditMode}
                  {...field}
                  value={field.value ?? ''}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="address"
            render={({ field }) => (
              <FormItem className="col-span-2">
                <InputAnimatedLabel
                  label="Address"
                  readOnly={!isEditMode}
                  {...field}
                  value={field.value ?? ''}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="city"
            render={({ field }) => (
              <FormItem>
                <InputAnimatedLabel
                  label="City"
                  readOnly={!isEditMode}
                  {...field}
                  value={field.value ?? ''}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="zip"
            render={({ field }) => (
              <FormItem>
                <InputAnimatedLabel
                  label="Zip Code"
                  readOnly={!isEditMode}
                  {...field}
                  value={field.value ?? ''}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="state"
            render={({ field }) => (
              <FormItem className="col-span-2">
                <InputAnimatedLabel
                  label="State"
                  readOnly={!isEditMode}
                  {...field}
                  value={field.value ?? ''}
                />
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </form>
    </Form>
  );
}
